const types = {
  GET_REQUEST: 'LEVELS_GET_REQUEST',
  GET_SUCCESS: 'LEVELS_GET_SUCCESS',
  GET_FAILURE: 'LEVELS_GET_FAILURE',
};

export default types;